export const KEY_POST_EMPLOYER_CREDITS = 'post.employer-credits.call';
export const KEY_GET_EMPLOYER_CREDITS = 'get.employer-credits.call';
export const KEY_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY =
  'post.employer-credits-summary-by-category.call';
export const KEY_POST_EMPLOYER_CREDITS_HISTORY = 'post.employer-credits-history.call';
export const KEY_GET_EMPLOYER_CREDITS_HISTORY = 'get.employer-credits-history.call';
